import { FilterGroup } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { CURRENT_USER_TOKEN } from "@redotech/redo-views-common/advanced-filters/current-user-token";
import {
  AdvancedFilterType,
  FilterOperator,
} from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import { SortDirection } from "@redotech/redo-views-common/table";
import {
  DEFAULT_PAGE_SIZE,
  viewTypes,
} from "@redotech/redo-views-common/views";

export enum CycleCountSystemView {
  ALL = "all",
  MINE = "my-cycle-counts",
}

const defaultColumns = [
  { key: "selected", width: 40, hidden: false },
  { key: "name", width: 260, hidden: false },
  { key: "skuCount", width: 110, hidden: false },
  { key: "status", width: 140, hidden: false },
  { key: "startDate", width: 150, hidden: false },
  { key: "dueDate", width: 150, hidden: false },
  { key: "progress", width: 170, hidden: false },
  { key: "updatedAt", width: 150, hidden: false },
  { key: "locationName", width: 150, hidden: false },
];

const mineFilterGroup: FilterGroup = {
  operator: FilterOperator.OR,
  clauses: [
    {
      name: "assignedUser",
      type: AdvancedFilterType.ARRAY_TO_STRING,
      operator: ArrayStringFilterOperator.ANY_OF,
      value: [CURRENT_USER_TOKEN],
    },
    {
      name: "assignedRole",
      type: AdvancedFilterType.ARRAY_TO_STRING,
      operator: ArrayStringFilterOperator.ANY_OF,
      value: [CURRENT_USER_TOKEN],
    },
  ],
};

export const StaticSystemViews: Record<
  CycleCountSystemView,
  viewTypes["cycle-counts"]
> = {
  [CycleCountSystemView.ALL]: {
    table: "cycle-counts",
    name: CycleCountSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: { direction: SortDirection.DESC, key: "startDate" },
    position: 0,
    isNotEditable: true,
  },
  [CycleCountSystemView.MINE]: {
    table: "cycle-counts",
    name: CycleCountSystemView.MINE,
    filters: [],
    filterGroup: mineFilterGroup,
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: { direction: SortDirection.DESC, key: "startDate" },
    position: 1,
    isNotEditable: true,
  },
};

export function friendlyViewName(view: viewTypes["cycle-counts"]): string {
  switch (view.name) {
    case CycleCountSystemView.ALL:
      return "All cycle counts";
    case CycleCountSystemView.MINE:
      return "My cycle counts";
    default:
      return view.name;
  }
}
